import { useMemo } from "react";
import { hasRoles } from "../../../core/Global";
import SideMenu, { ISideMenuItem } from "../../../components/layouts/aside/SideMenu";
import { FontAwesomeIcons } from "../../../core/Types";


interface ISideMenuGroup {
    name: string
    items: Array<{
        id: string
        name: string
        icon: FontAwesomeIcons
        link: string
        roles: string[]
    }>
}

export function useInventorySideMenuItems(): ISideMenuItem[] {
    return useMemo<ISideMenuItem[]>(() => {

        const groups: ISideMenuGroup[] = [
            {
                name: "Inventory",
                items: [
                    { id: "inventory-items", name: "Inventory Items", icon: "boxes-stacked", link: "/inventory/items", roles: ["ManageInventoryItems"] },
                    { id: "inventory-containers", name: "Warehouse Containers", icon: "warehouse-full", link: "/inventory/containers", roles: ["ManageWarehouseContainers"] },
                ]
            },
            {
                name: "Base Data",
                items: [
                    { id: "base-categories", name: "Categories", icon: "tags", link: "/inventory/base/categories", roles: ["ManageCategories"] },
                    { id: "base-vendors", name: "Vendors", icon: "industry-windows", link: "/inventory/base/vendors", roles: ["ManageVendors"] },
                    { id: "base-brands", name: "Brands", icon: "copyright", link: "/inventory/base/brands", roles: ["ManageBrands"] },
                    { id: "base-models", name: "Models", icon: "sitemap", link: "/inventory/base/models", roles: ["ManageBrandModels"] },
                    { id: "base-colors", name: "Colors", icon: "palette", link: "/inventory/base/colors", roles: ["ManageColors"] },
                    { id: "base-units", name: "Units", icon: "ruler", link: "/inventory/base/units", roles: ["ManageUnits"] },
                ]
            },
        ]

        const result: ISideMenuItem[] = []
        for (const g of groups) {
            const visible = g.items.filter(it => hasRoles(it.roles))
            if (visible.length === 0) continue
            result.push({ seperator: true, name: g.name })
            for (const it of visible) {
                result.push({ id: it.id, name: it.name, icon: it.icon, link: it.link })
            }
        }
        return result

    }, [])
}


export default function InventorySideMenu() {
    const items = useInventorySideMenuItems()
    return <SideMenu items={items} />
}
